(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nube-store-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindArrows(root) {
      var scrolly = root.querySelector('[data-nube-srev-scrolly]');
      var row = root.querySelector('[data-nube-srev-row]');
      var prev = root.querySelector('[data-nube-srev-prev]');
      var next = root.querySelector('[data-nube-srev-next]');
      if (!scrolly || !row || !prev || !next || scrolly.dataset.nubeSrevBound === 'true') return;
      scrolly.dataset.nubeSrevBound = 'true';

      function update() {
        var max = row.scrollWidth - row.clientWidth;
        prev.disabled = row.scrollLeft <= 4;
        next.disabled = row.scrollLeft >= max - 4;
      }

      prev.addEventListener('click', function () {
        row.scrollBy({ left: -row.clientWidth * 0.85, behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        row.scrollBy({ left: row.clientWidth * 0.85, behavior: 'smooth' });
      });

      row.addEventListener('scroll', update, { passive: true });
      update();
    }

    function init() {
      document.querySelectorAll('[data-nube-srev]').forEach(bindArrows);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nube-whatsapp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // La fila de fotos se centra sola (`justify-content:safe center`) y su
    // punto de arranque cambia según cuántas fotos entren por fila y el
    // ancho de pantalla. En vez de fijar un padding parejo a ojo, se mide
    // dónde cae la primera tarjeta y el título se alinea ahí — así las
    // fotos no se mueven de su lugar natural.
    function align(root) {
      var head = root.querySelector('[data-nube-warev-head]');
      var row = root.querySelector('[data-nube-warev-row]');
      var firstCol = row ? row.querySelector('.nube-warev-col') : null;
      if (!head || !row || !firstCol) return;

      var rowRect = row.getBoundingClientRect();
      var colRect = firstCol.getBoundingClientRect();
      var pad = Math.max(0, Math.round(colRect.left - rowRect.left));

      head.style.paddingLeft = pad + 'px';
    }

    // Flechas de escritorio: mueven la fila un "tramo" (visible menos un
    // poco, para que se note que sigue la misma tarjeta de referencia) y
    // se desactivan solas al llegar a cada punta.
    function bindArrows(root) {
      var wrap = root.querySelector('[data-nube-warev-wrap]');
      var row = root.querySelector('[data-nube-warev-row]');
      var prev = root.querySelector('[data-nube-warev-prev]');
      var next = root.querySelector('[data-nube-warev-next]');
      if (!wrap || !row || !prev || !next || wrap.dataset.nubeArrowsBound === 'true') return;
      wrap.dataset.nubeArrowsBound = 'true';

      function update() {
        var max = row.scrollWidth - row.clientWidth;
        prev.disabled = row.scrollLeft <= 4;
        next.disabled = row.scrollLeft >= max - 4;
      }

      prev.addEventListener('click', function () {
        row.scrollBy({ left: -row.clientWidth * 0.85, behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        row.scrollBy({ left: row.clientWidth * 0.85, behavior: 'smooth' });
      });

      row.addEventListener('scroll', update, { passive: true });
      update();
    }

    function init() {
      document.querySelectorAll('[data-nube-warev]').forEach(function (root) {
        align(root);
        bindArrows(root);
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        init();
        document.querySelectorAll('[data-nube-warev-row]').forEach(function (row) {
          row.dispatchEvent(new Event('scroll'));
        });
      }, 150);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
